import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useEffect, useRef } from "react";
import { ToastShow, toastSelector } from "../../redux/slices/toastSlice";

const ToastNotification = () => {
  const toastMessage = useSelector(toastSelector);

  const dispatch = useDispatch();

  const toastIdRef = useRef<any>(null);

  useEffect(() => {
    if (toastMessage.message) {
      toast.dismiss(); // Close existing toasts just in case

      if (toastMessage.type === "error") {
        toastIdRef.current = toast.error(toastMessage.message);
      } else {
        toastIdRef.current = toast.success(toastMessage.message);
      }

      setTimeout(() => {
        dispatch(ToastShow({ message: null, type: null }));
      }, 500);
    }
  }, [toastMessage?.message, dispatch]);

  return (
    <ToastContainer
      className="!z-[9999999]"
      position="top-right"
      autoClose={2500}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
    />
  );
};

export default ToastNotification;
